import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import { FaInstagram, FaYoutube, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

export default function Footer() {
  const { t } = useTranslation();
  
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__brand">
          <h2>{t('footer.brand_name')}</h2>
          <p>{t('footer.brand_tagline')}</p>
          <div className="footer__contact">
            <p><FaMapMarkerAlt /> {t('contact.location_text')}</p>
            <p><FaEnvelope /> linekginfo@gmail.com</p>
          </div>
        </div>

        <div className="footer__links">
          <h4>{t('footer.explore')}</h4>
          <a href="/">{t('nav.about')}</a>
          <a href="/team">{t('nav.team')}</a>
          <a href="/contact">{t('nav.contact')}</a>
        </div>

        <div className="footer__social">
          <h4>{t('footer.connect')}</h4>
          <a href="https://www.instagram.com/edu.moralvalues/" target="_blank" rel="noreferrer"><FaInstagram /> {t('footer.instagram')}</a>
          <a href="https://www.youtube.com/@moral-ed" target="_blank" rel="noreferrer"><FaYoutube /> {t('footer.youtube')}</a>
        </div>
      </div>

      <div className="footer__bottom">
        <p>© {new Date().getFullYear()} {t('footer.brand_name')}. {t('footer.rights')} <a href="https://line.kg" target="_blank" rel="noreferrer">line.kg</a></p>
        <a href="/privacy-policy" className="footer__privacy-link">{t('privacy.hero_title')}</a>
      </div>
    </footer>
  );
}
